export default {"src":"/_next/static/media/icon_replay.1da4a8a6.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};